import React from 'react';
import './Technologies.css';
import {
  FaReact,
  FaJava,
  FaHtml5,
  FaCss3Alt,
  FaGithub,
  FaJs,
  FaPython,
  FaGitAlt,
  FaDatabase,
  FaAndroid,
} from 'react-icons/fa';
import { SiAnaconda } from 'react-icons/si';

const technologies = [
  {
    name: 'React',
    icon: <FaReact />,
    link: 'https://react.dev/',
    color: '#61DAFB',
  },
  {
    name: 'JavaScript',
    icon: <FaJs />,
    link: 'https://developer.mozilla.org/pt-BR/docs/Web/JavaScript',
    color: '#F7DF1E',
  },
  {
    name: 'Java',
    icon: <FaJava />,
    link: 'https://docs.oracle.com/javase/8/docs/',
    color: '#F89820',
  },
  {
    name: 'Android',
    icon: <FaAndroid />,
    link: 'https://developer.android.com/',
    color: '#3DDC84',
  },
  {
    name: 'Python',
    icon: <FaPython />,
    link: 'https://docs.python.org/3/',
    color: '#3776AB',
  },
  {
    name: 'HTML5',
    icon: <FaHtml5 />,
    link: 'https://developer.mozilla.org/en-US/docs/Web/HTML',
    color: '#E34F26',
  },
  {
    name: 'CSS3',
    icon: <FaCss3Alt />,
    link: 'https://developer.mozilla.org/en-US/docs/Web/CSS',
    color: '#1572B6',
  },
  {
    name: 'SQL',
    icon: <FaDatabase />,
    link: 'https://dev.mysql.com/doc/',
    color: '#00758F',
  },
  {
    name: 'Git',
    icon: <FaGitAlt />,
    link: 'https://git-scm.com/doc',
    color: '#F05032',
  },
  {
    name: 'GitHub',
    icon: <FaGithub />,
    link: 'https://docs.github.com/',
    color: '#FFFFFF',
  },
  {
    name: 'Anaconda',
    icon: <SiAnaconda />,
    link: 'https://docs.anaconda.com/',
    color: '#44A833',
  },
];

const Technologies = () => {
  return (
    <section id="technologies" className="section reveal">
      <div className="section-header">
        <h2 className="section-title">Tecnologias</h2>
        <span className="section-subtitle">
          As ferramentas que uso no dia a dia para construir
        </span>
      </div>

      <div className="technologies-container">
        {technologies.map((tech, index) => (
          <a
            href={tech.link}
            target="_blank"
            rel="noopener noreferrer"
            key={index}
            className="technology"
            style={{ '--tech-color': tech.color }}
            aria-label={tech.name}
          >
            <div className="icon">{tech.icon}</div>
            <p>{tech.name}</p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Technologies;
